export default __webpack_public_path__ + "static/media/projects.2130aa22.svg";